export default {
  path: 'implementations',
  name: 'subscription/implementations',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-implementations" */ './Implementations')
}
